const normalizeDateValueFn = (value: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value;

export const formatDateFn = (
  value: string,
  options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
  }
) =>
  new Intl.DateTimeFormat("en-US", options).format(
    new Date(normalizeDateValueFn(value))
  );
